module.exports = __webpack_public_path__ + "static/media/Figure2.27e9489f.jpg";